var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignatureMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon-xMark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 54.21,
    viewBox: "0 0 20.001 54.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Down_long_arrow",
    "data-name": "Down long arrow",
    d: "M0,41.209v-34l9.993,6.136L20,7.209v34l-10,13Zm0-36V0L9.995,6.137,20,0V5.209L9.995,11.16Z",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Cross",
    d: "M16.59,15.656,19.045,13.2a.66.66,0,1,0-.934-.934l-2.455,2.455L13.2,12.267a.66.66,0,0,0-.934.934l2.455,2.455-2.455,2.455a.66.66,0,0,0,.934.934l2.455-2.455,2.455,2.455a.66.66,0,1,0,.934-.934Z",
    transform: "translate(-5.655 21.555)",
    fill: "#cecece"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureMark);
export default __webpack_public_path__ + "static/media/signature-mark.52a01f1d.svg";
export { ForwardRef as ReactComponent };